import React from 'react';
const testimonials = [{
  name: 'Francesca M.',
  role: 'Insegnante di 3ª classe',
  city: 'Milano',
  text: 'Ho risparmiato ore ogni settimana! I miei alunni adorano i laboratori e i risultati si vedono già dopo il primo mese.',
  stars: 5
}, {
  name: 'Giulia R.',
  role: 'Insegnante di 1ª classe',
  city: 'Roma',
  text: 'Finalmente un kit completo e ben organizzato. Le verifiche pronte mi hanno salvato la vita, soprattutto per le prove INVALSI.',
  stars: 5
}, {
  name: 'Chiara L.',
  role: 'Insegnante di 5ª classe',
  city: 'Napoli',
  text: 'La progressione didattica è perfetta. I bambini che prima odiavano la matematica ora alzano la mano per rispondere!',
  stars: 5
}, {
  name: 'Sara T.',
  role: 'Insegnante di sostegno',
  city: 'Bologna',
  text: 'Il Kit Recupero Rapido per BES/DSA è una risorsa incredibile. Percorsi chiari, inclusivi e facili da adattare.',
  stars: 5
}, {
  name: 'Valentina P.',
  role: 'Insegnante di 2ª classe',
  city: 'Torino',
  text: 'La Dirigente mi ha fatto i complimenti per la programmazione. Non le ho detto che ci ho messo solo 5 minuti! 😄',
  stars: 5
}, {
  name: 'Elena B.',
  role: 'Insegnante di 4ª classe',
  city: 'Firenze',
  text: 'Le slide per la LIM sono spettacolari. I bambini restano incantati e capiscono concetti che prima sembravano impossibili.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-365">
      <div className="max-w-5xl mx-auto" data-id="element-366">
        <div className="text-center mb-14" data-id="element-367">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-368">
            Cosa dicono le insegnanti
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-369">
            Oltre <span className="text-primary font-bold" data-id="element-370">15.000 docenti</span>{' '}
            hanno già scelto Matematica Pronta
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-371">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-372">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-373"></div>

              {/* Stars */}
              <div className="flex items-center gap-0.5 relative z-10" data-id="element-374">
                {Array.from({
              length: t.stars
            }).map((_, j) => <span key={j} className="text-secondary text-lg" data-id="element-375">
                    ⭐
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-base leading-relaxed font-medium relative z-10 flex-1" data-id="element-376">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-377">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-378">
                  <span className="text-sm font-bold text-primary" data-id="element-379">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-380">
                  <p className="text-text-main font-bold text-sm" data-id="element-381">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-382">
                    {t.role} · {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}